import { useState } from "react";
import { Box } from "@mui/material";
import { useNavigate } from "react-router";

import NotificationCardWrapper from "../NotificationCardWrapper";
import useFollow from "../../../../hooks/UseFollow";
import CustomAvatar from "../../CustomAvatar";
import CustomButton from "../../CustomButton";
import { useEffect } from "react";

const FollowNotification = ({ data }) => {
  const [followBtn, setFollowBtn] = useState(false);
  const [handleFollowBtn] = useFollow(data?.actor, followBtn, setFollowBtn);
  const navigate = useNavigate();

  useEffect(() => {
    data && setFollowBtn(data.actor.followed);
  }, [data]);

  return (
    <>
      <NotificationCardWrapper
        styling={{ alignItems: "center" }}
        firstChild={
          <CustomAvatar
            size={48}
            src={data?.actor.avatar}
            alt={data?.actor.avatar}
            borderSize={1.5}
            link={`/profile/${data.actor.username}`}
          />
        }
        seccondChild={
          <Box
            style={{ width: "100%" }}
            onClick={() => navigate(`/profile/${data.actor.username}`)}
          >
            <b>{data?.actor.username}</b> followed you!
          </Box>
        }
        ThirdChild={
          <CustomButton
            title={followBtn ? "Followed" : "Follow"}
            onClick={() => handleFollowBtn()}
            fSize='12px'
            width='61px'
            height='32px'
            bShadow='2px'
            color={followBtn ? "white.main" : "black.main"}
            bgColor={followBtn ? "black.main" : "primary.main"}
          />
        }
      />
    </>
  );
};

export default FollowNotification;
